import { useEffect, useState } from 'react';
import { getPriceListConfigurations } from '../../api';
import { fetchCatalogDelta } from '../../utils/catalogDelta';
import { normalizeQuickPriceCatalog } from './quickPriceListModel';

// Read each selected branch's own cost and rule. Never substitute the current
// branch's data while another branch is loading or unavailable.
export default function useTemporaryPriceBranchFormats({ isOpen, branchId, branchIds, targetIds }) {
  const [state, setState] = useState({});
  const key = JSON.stringify([isOpen, branchId, branchIds, targetIds]);
  useEffect(() => {
    const [open, currentId, selectedIds, priceIds] = JSON.parse(key);
    let active = true;
    setState({});
    if (!open || !currentId || !priceIds.length) return undefined;
    selectedIds.filter((id) => String(id) !== String(currentId)).forEach(async (id) => {
      setState((current) => ({ ...current, [id]: { loading: true } }));
      try {
        const response = await fetchCatalogDelta((params) => getPriceListConfigurations(id, params), { priceIds });
        const formats = Object.fromEntries(normalizeQuickPriceCatalog(response)
          .flatMap((product) => product.varieties.flatMap((variety) => variety.formats))
          .map((format) => [format.id, format]));
        if (active) setState((current) => ({ ...current, [id]: { formats } }));
      } catch (error) {
        if (active) setState((current) => ({ ...current, [id]: {
          error: error.response?.data?.message || 'No se pudo cargar el costo, la regla y el precio actual de esta sucursal.',
        } }));
      }
    });
    return () => { active = false; };
  }, [key]);
  return state;
}
